import Icon from '../../components/Icon.vue'

Icon.register({"brands/cuttlefish":{"width":440,"height":512,"paths":[{"d":"M344 305.5C326.5 337.1 286.6 360 248 360 191.4 360 144 312.6 144 256S191.4 152 248 152C286.6 152 326.5 174.9 344 206.5 357.7 155.6 385.7 113.2 431 88.7 385.7 39.1 320.5 8 248 8 111 8 0 119 0 256S111 504 248 504C320.5 504 385.7 472.9 431 423.3 385.7 398.8 357.7 356.4 344 305.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cuttlefish.js
// module id = 1oNZ
// module chunks = 0